module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/175/assets/images/d3037cbb691672a1fe058ba507d7ddf9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/icon_classes.svg
// module id = WCb1
// module chunks = 1